import { ArcElement, CategoryScale, Chart, Title, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

Chart.register(ArcElement, Title, CategoryScale, Tooltip);

type DoughnutChartProps = {
  colors: string[];
  values: number[];
  labels?: string[];
  showTooltips?: boolean;
  /** Percentage of the chart that is cut out of the middle (0-100). Higher = thinner ring. Default: 75 */
  cutout?: number;
};

const DoughnutChart = ({
  colors,
  values,
  labels = [],
  showTooltips = false,
  cutout = 75,
}: DoughnutChartProps) => {
  const chartData = {
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        hoverOffset: 4,
      },
    ],
    labels,
  };

  const totalValue = values.reduce((sum, current) => current + sum, 0);

  const chartOptions = {
    cutout: `${cutout}%`,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        intersect: false,
        backgroundColor: 'white',
        titleColor: '#3b6d66',
        bodyColor: '#3b6d66',
        footerColor: 'blue',
        boxWidth: 20, // Width of the color box
        boxPadding: 5, // Padding inside the color box
        bodySpacing: 10, // Spacing between color box and text
        borderWidth: 2, // Border width
        borderColor: '#3b6d66', // Border color
        shadowOffsetX: 3, // Shadow horizontal offset
        shadowOffsetY: 3, // Shadow vertical offset
        shadowBlur: 4, // Shadow blur
        shadowColor: 'rgba(66, 71, 76, 0.16)',
        displayColors: false,
        callbacks: {
          label(context: any) {
            const labelIndex = context.dataIndex;

            return labels
              ? `${labels[labelIndex]} - ${(
                  (values[labelIndex] / totalValue) *
                  100
                ).toFixed(2)} %`
              : '';
          },
        },
      },
    },
  };

  return (
    <Doughnut
      data={chartData}
      options={{
        ...chartOptions,
        plugins: {
          ...chartOptions.plugins,
          tooltip: {
            ...chartOptions.plugins.tooltip,
            enabled: showTooltips,
          },
        },
      }}
    />
  );
};

export { DoughnutChart };
